<bt-image-design [model]="model" [value]="model.value"></bt-image-design>